var React = require('react');

function ArrowHomeServices (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.4"},[React.createElement("path",{"d":"M107.335 67.3442L20 159.791L109 254","stroke":"#E43C2E","strokeWidth":"28","key":0}),React.createElement("path",{"d":"M107.335 10.0001L20 102.447L109 196.656","stroke":"#A5C7BE","strokeWidth":"28","key":1})]));
}

ArrowHomeServices.defaultProps = {"width":"85","height":"264","viewBox":"0 0 85 264","fill":"none"};

module.exports = ArrowHomeServices;

ArrowHomeServices.default = ArrowHomeServices;
